/* WishANDdesign: Globo product-options helper (2026-10-21)
   - preselects the most-ordered thread/bead (Black / Black mettalic) when nothing is chosen
   - one-line name fields
   - live Morse bead preview under each name field */
(function () {
  var DEFAULTS = { 'Thread color': 'Black', 'Dash/Dots': 'Black mettalic' };
  var MORSE = { A: '.-', B: '-...', C: '-.-.', D: '-..', E: '.', F: '..-.', G: '--.', H: '....', I: '..', J: '.---', K: '-.-', L: '.-..', M: '--', N: '-.', O: '---', P: '.--.', Q: '--.-', R: '.-.', S: '...', T: '-', U: '..-', V: '...-', W: '.--', X: '-..-', Y: '-.--', Z: '--..', 0: '-----', 1: '.----', 2: '..---', 3: '...--', 4: '....-', 5: '.....', 6: '-....', 7: '--...', 8: '---..', 9: '----.' };
  var BEAD = { 'Sterling Silver': '#c9ccd1', 'Gold': '#d4af37', 'Rose gold': '#d8a093', 'Black mettalic': '#2b2b2e' };
  var THREAD = { White: '#f2f2f2', Black: '#1a1a1a', Gray: '#8a8a8a', Pink: '#f4a7b9', 'Hot pink': '#e0457b', 'Light Purple': '#c9a6e4', Lavender: '#b8a9d9', Purple: '#6b3fa0', 'Olive green': '#6b7a3a', 'Lime green': '#8cc63f', Red: '#c0392b', Navy: '#1f2f5a' };

  function radios(app, name) {
    return [].slice.call(app.querySelectorAll('input[type=radio]')).filter(function (i) { return i.name.trim() === name; });
  }
  function chosen(app, name) {
    var r = radios(app, name).filter(function (i) { return i.checked; })[0];
    return r ? r.value : '';
  }

  function preview(app, ta) {
    var p = ta.name.indexOf('2') > -1 ? 'Bracelet 2 ' : '';
    var box = document.createElement('div');
    box.className = 'wd-morse';
    box.setAttribute('aria-hidden', 'true');
    (ta.closest('.gpo-input-wrap') || ta).insertAdjacentElement('afterend', box);
    function draw() {
      var word = ta.value.toUpperCase().replace(/[^A-Z0-9 ]/g, '').trim();
      box.style.setProperty('--wd-bead', BEAD[chosen(app, p + 'Dash/Dots')] || '#2b2b2e');
      box.style.setProperty('--wd-thread', THREAD[chosen(app, p + 'Thread color')] || '#1a1a1a');
      if (!word) { box.innerHTML = ''; return; }
      box.innerHTML = '<span class="wd-morse__row">' + word.split('').map(function (c) {
        if (c === ' ') return '<i class="wd-gap"></i>';
        return '<b>' + MORSE[c].split('').map(function (s) { return '<i class="' + (s === '.' ? 'wd-dot' : 'wd-dash') + '"></i>'; }).join('') + '</b>';
      }).join('') + '</span><small>' + word + ' in Morse code</small>';
    }
    ta.addEventListener('input', draw);
    app.addEventListener('change', draw);
    app.addEventListener('click', function () { setTimeout(draw, 0); });
    draw();
  }

  function init(app) {
    if (app.dataset.wd) return;
    app.dataset.wd = '1';
    ['', 'Bracelet 2 '].forEach(function (p) {
      Object.keys(DEFAULTS).forEach(function (k) {
        if (chosen(app, p + k)) return;
        var r = radios(app, p + k).filter(function (i) { return i.value === DEFAULTS[k]; })[0];
        if (r) r.click();
      });
    });
    [].slice.call(app.querySelectorAll('textarea.gpo-textarea')).forEach(function (ta) {
      ta.rows = 1;
      ta.addEventListener('keydown', function (e) { if (e.key === 'Enter') e.preventDefault(); });
      preview(app, ta);
    });
  }

  var tries = 0;
  (function wait() {
    var app = document.querySelector('.gpo-app');
    if (app && app.querySelector('input[type=radio]')) return init(app);
    if (++tries < 40) setTimeout(wait, 250);
  })();
})();
